module.exports = __webpack_public_path__ + "static/media/cr.7f553c0a.svg";